export default function ({ $axios, store, redirect, $sentry, app }, inject) {
  $axios.setHeader('DeviceType', 'web')

  $axios.onResponseError((error) => {
    handleError(error)
  })

  const api = $axios.create({
    timeout: 1000000
  })
  api.setBaseURL(process.env.BASE_API)

  api.onRequest((config) => {
    config.headers.DeviceType = 'Web'

    if (store.state.user.auth.token) {
      config.headers.Authorization = `Bearer ${store.state.user.auth.token}`
    }

    return config
  })

  api.onResponseError((error) => {
    handleError(error)
  })

  const whiteListErrorStatus = [401] // value can be multiple : [401, 404]

  // this list error message was handled by showing error UI and wouldn't send to sentry
  const whiteListSentryErrorMessage = ['TNC_CONFIRMATION', 'NOT_FOUND', 'LIMIT_EXCEEDED', 'ALREADY_TAKE', 'NOT_ALLOW', 'CONSULT_TIME_NOT_ALLOW', 'GP_FORBID_CREATE_SCHEDULE', 'EMAIL_NOT_FOUND', 'RESOURCE_NOT_FOUND', 'PASSWORD_USED', 'E_SIGNATURE', 'LINK_EXPIRED', 'EMAIL_EXISTS', 'PHONE_EXISTS']

  function clearAllStorage () {
    const allCookies = app.$cookiz.getAll()
    Object.keys(allCookies).forEach((key) => {
      app.$cookiz.remove(key)
    })

    if (process.client) {
      try {
        localStorage.clear()
        sessionStorage.clear()
      } catch {
        // do nothing
      }
    }
  }

  function handleError (error) {
    if (error.response && whiteListErrorStatus.includes(error.response.status)) {
      // eslint-disable-next-line
      if ($nuxt.$route.path.includes('console')) {
        // eslint-disable-next-line
        $nuxt.$emit('destroySocket')
        // eslint-disable-next-line
        $nuxt.$swal({
          icon: 'error',
          title: 'Sesi Habis',
          text: 'Anda telah keluar dari akun. Silakan masuk kembali.'
        }).then(() => {
          // clear all browser storage
          clearAllStorage()

          store.dispatch('user/resetDataUser').then(() => {
            redirect('/auth/login')
          })
        })
      }
    } else if (!(error.response && error.response.data && whiteListSentryErrorMessage.includes(error.response.data.Message))) {
      $sentry.captureException(error)
      store.dispatch('globalSocket/log', {
        data: `${JSON.stringify(error.response)}`,
        status: 'ERROR'
      })
    }
    return Promise.reject(error)
  }

  inject('api', api)
}
